import React from 'react'
import { Box, Link, Text } from '@workwhile/ui'
import { DateWithRelativeTime } from 'components/Table/DateWithRelativeTime'
import { IssueSection } from './IssueSection'
import { useInvoiceIssuesContextValue } from '../context/InvoiceIssuesProvider'
import * as ROUTES from 'constants/routes'

export const StaleUnfinalizedSection = () => {
  const {
    state: {
      data: { staleUnfinalizedCharges },
    },
  } = useInvoiceIssuesContextValue()

  return (
    <IssueSection
      title="Stale unfinalized charges"
      description="Companies with charges still open after the related shift ended more than 7 days ago."
      emptyMessage="No companies with stale unfinalized charges."
      isEmpty={staleUnfinalizedCharges.length === 0}
    >
      {staleUnfinalizedCharges.map((issue) => (
        <Box
          key={issue.company.id}
          border="1px solid"
          borderColor="neutrals.100"
          borderRadius="small"
          p={3}
          mb={2}
        >
          <Text fontWeight="500" mb={1}>
            <Link
              to={`${ROUTES.CHARGES}?company=${issue.company.id}&invoiced=false`}
            >
              {issue.company.name}
            </Link>{' '}
            ({issue.company.id}) — {issue.charges.length} charge
            {issue.charges.length === 1 ? '' : 's'}
          </Text>
          {issue.charges.map((charge) => (
            <Text key={charge.id} color="lightText" ml={2}>
              Charge {charge.id} · shift{' '}
              <Link
                to={ROUTES.SHIFT_DETAIL.replace(
                  ':shiftId',
                  String(charge.shiftId)
                )}
              >
                {charge.shiftId}
              </Link>{' '}
              ended{' '}
              <DateWithRelativeTime
                date={charge.shiftEndedAt}
                variant="inline"
              />
            </Text>
          ))}
        </Box>
      ))}
    </IssueSection>
  )
}
